
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/3-minuts",
      function () {
        return require("private-next-pages/3catinfo/3-minuts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/3-minuts"])
      });
    }
  